export default {
  stubs: {
    welcomePage: {
      todo: {
        fistSlide: {
          title: 'Welcome to To-Do list!',
          description:
            'This personal tab is a key to your efficiency. Here you will create all prioritized lists of all the tasks that you need to carry out. From now on, you make sure that you don’t forget anything important',
        },
        secondSlide: {
          title: 'Create. Act. Enjoy.',
          description:
            'Organize your personal to-do list and became much more productive with hubmee.  Prioritize your tasks intelligently and you’ll focus your time and energy on high-value activities.',
        },
        thirdSlide: {
          title: 'Edit a To-Do list',
          description:
            'To use hubmee’s to-do list, it’s super easy to stay on the top of important tasks and piles of actions. You don’t get stressed anymore, you control everything.',
        },
        fourthSlide: {
          title: 'Edit a To-Do list',
          description:
            'To use hubmee’s to-do list, it’s super easy to stay on the top of important tasks and piles of actions. You don’t get stressed anymore, you control everything.',
        },
        fifthSlide: {
          title: 'Your opinion matters',
          description:
            'Was this guide helpful? Feel free to leave your feedback or contact hubmee support to find answers to your questions.',
        },
      },
      garage: {
        fistSlide: {
          title: 'Welcome to Garage! ',
          description:
            'This is your reliable assistant in solving many problems related to vehicle payments and sharing information. We have taken care to ensure that you no longer have to worry about future payments and other important details.',
        },
        secondSlide: {
          title: 'General info',
          description: `Let's start by creating a card filled with information about your transport.`,
        },
        thirdSlide: {
          title: 'Insurance',
          description:
            'Using the Garage tab will become even more convenient when you fill in the information about the insurance for your vehicle.',
        },
        fourthSlide: {
          title: 'Insurance',
          description:
            'Using the Garage tab will become even more convenient when you fill in the information about the insurance for your vehicle.',
        },
        fifthSlide: {
          title: 'Stickers',
          description: `Now let's figure out how to use Stickers. It will take you just a couple of minutes to fill in each of them; let's see it in more detail!`,
        },
        sixthSlide: {
          title: 'Sharing',
          description: 'Fine! Now you can share information about your transport with your friends.',
        },
      },
      planner: {
        fistSlide: {
          title: 'Welcome to Journal!',
          description:
            'This is your personal planner tab – a convenient space to plan your days and weeks!\n' +
            'Everything that happens to you in the system is displayed on this tab. ',
        },
        secondSlide: {
          title: 'Build a productive task',
          description:
            'We know that each detail plays an important role in keeping track of your progress. hubmee found a solution to simplify all management processes and help you to achieve desired goals.',
        },
        thirdSlide: {
          title: 'Schedule effectively!',
          description:
            'With our recurrence feature, you have the ability to effectively schedule your repeating actions Want to see this in action? Try now!',
        },
      },
      roadmap: {
        fistSlide: {
          title: 'Welcome to Tasks!',
          description:
            'hubmee exactly knows what you need. Start to create a bold vision of your strategic goals. It increases flexibility in your workflow and helps reduce backlogs. Turn your aspirations into reality.',
        },
        secondSlide: {
          title: ' Build a productive task',
          description:
            'We know that each detail plays an important role in keeping track of your progress. hubmee found a solution to simplify all management processes and help you to achieve desired goals.',
        },
        thirdSlide: {
          title: 'Schedule effectively',
          description:
            'With our recurrence feature, you have the ability to effectively schedule your repeating actions. \n' +
            'Want to see this in action? Try now!',
        },
        fourthSlide: {
          title: 'Filters and statuses',
          description: 'Diversity of features for easy use, all for your convenience',
        },
        fifthSlide: {
          title: 'Drag and Drop',
          description:
            'In a drag-and-drop technology, you will never get to be anxious about what is going on with your planning procedure. It is smartly developed to view the effects of your actions instantly.',
        },
      },
      events: {
        fistSlide: {
          title: 'Welcome to Events!',
          description:
            'This tab will help you plan your time productively and evaluate the possibility of holding a meeting at a specific time.Check the data on past and upcoming meetings, and conveniently organize new ones! ',
        },
        secondSlide: {
          title: 'Create an event',
          description:
            'Properly plan and organize everything in order to pass your events up to par. hubmee is ready to take on this responsibility with you.',
        },
        thirdSlide: {
          title: 'Schedule effectively!',
          description:
            'With our recurrence feature, you have the ability to effectively schedule your repeating actions. hubmee has thought of everything in advance.',
        },
        fourthSlide: {
          title: 'Invite Users',
          description:
            'Add friends! Invite people from your network and keep track of their status regarding a particular event (going / not going / maybe). Each participant will be able to receive instant notifications of all event updates.',
        },
        fifthSlide: {
          title: 'Docs & Photos',
          description:
            'Add documents and photos to plan your upcoming event more accurately. You can also set the privacy for the added files yourself and choose the people who will have access to them. ',
        },
      },
      calendar: {
        fistSlide: {
          title: 'Welcome to Calendar!',
          description:
            'Have you ever thought about how your planning would be without a calendar? This personal tab is a useful tool for keeping track of upcoming events, deadlines, and milestones.',
        },
        secondSlide: {
          title: 'Build a productive task',
          description:
            'We know that each detail plays an important role in keeping track of your progress. hubmee found a solution to simplify all management processes and help you to achieve desired goals.',
        },
        thirdSlide: {
          title: 'Create an event',
          description:
            'Together with hubmee creating events can be less complex and easier to manage. We take care about all required details and even more.',
        },
        fourthSlide: {
          title: 'Schedule effectively',
          description:
            'With our recurrence feature, you have the ability to effectively schedule your repeating actions. Want to see this in action? \n' +
            'Try now!',
        },
      },
      backlog: {
        fistSlide: {
          title: 'Welcome to Backlog!',
          description:
            'You asked, hubmee delivered— keep essential tasks under a separate tab without deadlines until you’re ready to set a time frame. From now on, all your burdens lay on our shoulders.',
        },
        secondSlide: {
          title: 'Build a productive task',
          description:
            'We know that each detail plays an important role in keeping track of your progress. hubmee found a solution to simplify all management processes and help you to achieve desired goals.',
        },
        thirdSlide: {
          title: 'Turn your task into reality',
          description:
            'No matter how daunting your dreams feel, nothing is too big to achieve. Don’t be afraid to put your tasks into action.',
        },
        fourthSlide: {
          title: 'Use filters ',
          description: `There are times when you want to view only a particular type of information in your task. Give it a try and use hubmee’s filters! It's essential to understand the specific needs of your task.`,
        },
      },
      archive: {
        fistSlide: {
          title: 'Welcome to Archive!',
          description:
            'If you take advantage of many services, you undoubtedly have a large amount of data stored. This hub will teach you how to find and organize all tasks and events like a pro.',
        },
        secondSlide: {
          title: 'Choose the way how to archive',
          description:
            'It doesn’t take long hours or days to archive your tasks or events. We have thought about everything in advance to allow you to do this on your own or automatically. ',
        },
        thirdSlide: {
          title: 'Choose the way how to archive',
          description:
            'It doesn’t take long hours or days to archive your tasks or events. We have thought about everything in advance to allow you to do this on your own or automatically. ',
        },
      },
      feedbackScreen: {
        title: 'Your opinion matters',
        description: {
          partFirst: 'Was this guide helpful? Feel free to leave your',
          feedback: 'feedback',
          partSecond: 'or contact',
          hubmeeSupport: 'hubmee support',
          partThird: 'to find answers to your questions.',
        },
        button: 'Let’s get started',
      },
    },
    commentsStub: {
      description: 'You don’t have any comments yet. Let’s write the first comment.',
    },
    chatNotFoundPersonStub: {
      description:
        "It looks like this person is still not in your network. Let's send more connection requests and start new chats",
    },
    chatNotFoundGroupStub: {
      description: 'Hmm, we couldn’t find the chat you were looking for. Please, try again',
    },
    personalChatStub: {
      title: 'Chat',
      description: 'Stay close to your favorite people and plan together',
      subDescription: 'Choose a person to start chatting with',
      imageAlt: 'Chat stub',
    },
    groupChatStub: {
      title: 'Chat',
      description: 'Stay close to your favorite people and plan together ',
      subDescription: 'Click plus to create a group chat',
      imageAlt: 'Chat stub',
    },
    noMessagesGroupChatStub: {
      title: 'Chat',
      description: 'Stay close to your favorite people and plan together',
      subDescription: 'dawdaw',
      imageAlt: 'Chat stub',
    },
    noMessagesPersonalChatStub: {
      title: 'You are now connected To the Chat',
      imageAlt: 'Chat stub',
    },
    network: {
      networkInviteStub: {
        description:
          "Oops! It looks like this person is not in the system yet. Don't worry, we are here to save this contact for you.",
        subDescription:
          "Don't forget to invite your friends and family to join us! Motivate them to reach new goals together.",
      },
      networkContactsStub: {
        title: 'Contacts',
        description: "It's a good idea to add your most common contacts to your hubmee account.",
        subtitle: 'Looks like you don`t have any contacts',
      },
      myNetworkStub: {
        title: 'My Network',
        description: 'Create your personalized network and keep in touch with everyone.',
        subtitle: 'Looks like you don’t have any connections now',
      },
      networkConnectedStub: {
        title: 'Connected',
        description:
          'With everyone’s busy schedules try to find some\n' +
          'free time for a simple chat with the close ones:\n' +
          "ask what's new with them, and share news from your own life.",
        subtitle: 'Looks like you don`t have any connections',
      },
      networkPendingRequestStub: {
        title: 'Pending Request',
        description:
          'Connect with your family, friends, and \n' +
          'acquaintances easily. Just add their email or phone\n' +
          "number and we'll invite them to your network.",
        subtitle: "You don't have any pending requests for now \n",
      },
      networkSentRequestStub: {
        title: 'Sent Request',
        description: "As only someone invites you to their 'network, we'll inform you right away!'",
        subtitle: "You don't have any sent requests for now ",
      },
      networkFutureSentRequestStub: {
        title: 'Future Sent Request ',
        description:
          'Invite your friends to register in hubmee and help out them to make the first step toward a new life. Their success is your biggest reward.',
        subtitle: "You don't have any future sent requests for now",
      },
    },
    todo: {
      todoStub: {
        title: 'To-Do',
        description: 'A simple way to achieve your goals or to share daily shopping lists quickly',
        subtitle: 'Click plus to add your first To-Do',
      },
      checklistNoItemsStub: {
        title: 'Your checklists will appear here.',
        description: 'Create checklists to start seeing them.',
      },
      notesNoItemsStub: {
        title: 'Your notes will appear here.',
        description: 'Create notes to start seeing them.',
      },
      baseStub: {
        title: 'Create checklist or note to start seeing them here.',
      },
    },
    planner: {
      motivationQuotesStub: {
        description1: 'Do not let your day be sluggish. Make it productive!',
        description2: 'Success is when you control your time. You are on the right track with hubmee.',
        description3: 'Keep your goals and achieve them with the correct planning.',
        description4: 'Take care of your time today, and the result will impress you in the future.',
        description5: 'Change your life today with good planning and forget about the problems tomorrow.',
        description6:
          'Do you know what time it is? It’s the right time to start planning your new day with hubmee.',
        description7: 'Don’t wait and start to plan right now. Something impressive is waiting for you!',
        description8: 'Success is not about money. It’s about proper planning. Just try!',
        description9: 'Plan now to see your improvement later.',
        description10:
          'Even now, you are doing a good job. You change your life through good planning. We are proud of you!',
        description11:
          'Good planning is the best way to change your life. So don’t hesitate to show the world what you can do right now.',
        description12: 'Start to plan everything to become a better version of yourself.',
        description13:
          'One of the happiest moments in life is when you control your time. And we are here to help.',
        description14: 'It’s time to plan something exciting.',
        description15: 'Today, you have the power to change your life. Just do the first step.',
        description16:
          'Planning is a powerful thing. Make a proper to-do list now, and your life will start to change.',
      },
      plannerListNoItemStub: {
        title: 'Journal',
        description: 'Let the day follow your rules with a well-ordered schedule',
        subtitle: 'Click plus to add your first task or event',
      },
    },
    event: {
      eventListNoItemStub: {
        title: 'Events',
        description: `Watch the wholesome picture of your future events`,
        subtitle: 'Click plus to add your first event',
      },
    },
    roadmap: {
      roadmapNoItemStub: {
        title: 'Tasks',
        description: `Track your task progress and get things done faster than ever`,
        subtitle: 'Click plus to add your first task',
      },
    },
    backlog: {
      backlogNoItemStub: {
        title: 'Backlog',
        description: `Work peacefully or enjoy the study process without any rush`,
        subtitle: 'Click plus to add your first task',
      },
    },
    archive: {
      archiveNoItemStub: {
        title: 'Archive',
        description: `You’ll have here everything you completed and archived in hubmee`,
        subtitle: 'The first step to archiving the task or event is to use the action menu in it.',
      },
    },
    noFilterMatchStub: {
      title: 'No filter match',
      description: 'No items matching this filter',
    },
    garage: {
      garageNoVehiclesStub: {
        title: 'Garage',
        description: 'Let us take care of your car insurance and oil change',
        subtitle: 'Click plus to add your car',
      },
      noItemsStub: {
        title: 'You haven’t added anything to your Garage. It’s time to change it.',
      },
    },
    sidebarNotifications: {
      newsStub: 'You have no news yet',
      requestsStub: 'You have no requests yet',
    },
    noInternetConnectionStub: {
      title: 'No internet connection',
      subtitle: 'Please check your internet connection and reopen the app',
    },
  },
};
